import React, { useRef } from "react";
import {
  BaseTextField,
  BasePaper,
  PageHeaderWithTabs,
  FormSwitch,
  BaseCheckBox,
  TextEditor,
  MasterLayoutMiddle,
  FooterInner,
  AlertDialogueAdvance,
  AlertAction
} from "@dclab/dc-react-ui-kit";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import "./style.css";
import { saveAsDraft } from "../../components/DonationForm/Apis";
import { getOrganizationData } from "../Organization/api";
import { AddTermOfServicesWebsite, GetTermOfServicesWebsite, updateTermOfServicesWebsite } from "./api";
import { connect } from "react-redux";
import { PagesAction } from "../../redux/actions/pages";
import messages_content from '../../utils/messages.json';
const {
  token_expired,
  quick_access_limit_axeeded,
  Your_changes_has_been_saved_as_draft,
  Your_changes_has_been_published
} = messages_content;
function TermsOfServices(props) {
  const history = props.history;
  const [Title, setTitle] = React.useState('')
  const [value, setValue] = React.useState(0);
  const [showAlert, setshowAlert] = useState(false);
  const [success, setsuccess] = useState(false);
  const [organizationData, setOrganizationData] = useState([])
  const [open, setAlertModal] = useState(false);
  const [dischard_changes, setdischard_changes] = useState(0);
  const [changes, setCheckChanges] = useState(false);
  const [homepageButton, setHomePageButton] = useState(false);
  const [Loader, setLoader] = React.useState(true);
  const [error, seterror] = useState(false);
  const [QuickLimit, setQuickLimit] = useState(false);
  const [ErrorFound, setErrorFound] = useState(false);
  const [EmptyData, setEmptyData] = useState({})
  const [pagesAll, setPagesAll] = useState({})
  const [integrateData, setIntegrateData] = useState({});
  const unblockHandle = useRef();
  const [textValue, setTextValue] = useState([
    { type: "paragraph", children: [{ text: "" }] },
  ]);
  const [saved_route, setRoute] = useState('');
  useEffect(() => {
    unblockHandle.current = history.block((route) => {
      setRoute(route.pathname)
      changes && visibleModal()
      return changes === true ? false : true
    });
    return () => {
      unblockHandle.current = false
      !window.location.pathname.includes('tos') && localStorage.removeItem('term-of-services')
    }
  }, [changes])
  useEffect(() => {
    const page_no = localStorage.getItem('term-of-services')
    setValue(page_no ? +page_no : 0);
    async function getorganization() {
      try {
        const token = localStorage.getItem('authToken')
        const orgId = localStorage.getItem('orgID')
        const getOraganization = await getOrganizationData(orgId, token);
        // try {
        //   const getTermsAndCondition = await GetTermOfServicesWebsite(token);
        //   let descApi = getTermsAndCondition.data.body.data;
        //   let desc = JSON.parse(descApi.description);
        //   setEmptyData(descApi);
        //   setTextValue(desc);
        // } catch (err) {
        //   console.log(err)
        // }
        const orgIntegrate = getOraganization?.data?.body?.data?.enabledIntegrations;
        const data = orgIntegrate?.deenweb?.pages;
        const oraganization_data = data?.termsOfServices;
        const tosDescription = orgIntegrate?.deenweb?.settings?.termsOfService?.description;
        tosDescription && setTextValue(JSON.parse(tosDescription));
        
        setIntegrateData(orgIntegrate);
        setPagesAll(data);
        setOrganizationData(oraganization_data);
        setTitle(oraganization_data.title);
        setHomePageButton(oraganization_data.enablePage)
        setChecked(oraganization_data.quickAccess)
        setLoader(false);
      }
      catch (error) {
        setLoader(false);
        seterror(error.response && error.response.data.message)
        setTimeout(() => {
          seterror(false)
        }, 8000);
      }
    }
    getorganization()
  }, [])
  const handleChange = (event, newValue) => {
    changes && (Title === '' ? setErrorFound(true) : setAlertModal(true))
    // changes && setAlertModal(true)
    !changes && setValue(newValue);
    !changes && localStorage.setItem('term-of-services', newValue)
    setdischard_changes(newValue)
  };
  function visibleModal() {
    setAlertModal(true)
  }
  const object = [
    {
      label: "Contents",
      item: "Contents",
    },
    {
      label: "Page setup",
      item: "Page setup",
    },
    
  ];
  const saveChanges = async () => {
    const orgId = localStorage.getItem('orgID');
    const token = localStorage.getItem('authToken');
    if (Title === '') {
      setErrorFound(true)
    } else {
      // const data = {
      //   "addSelectedArrayData": {
      //       "enabledIntegrations.deenweb.pages.termsOfServices": {
      //         title: Title,
      //         status: homepageButton ? 'active' : 'inactive',
      //         enablePage: homepageButton,
      //         quickAccess: checked,
      //         lastEdited: new Date()
      //       }
      //     },
      //   }
        const data = {
          enabledIntegrations: {
            ...integrateData,
            deenweb: {
              ...integrateData.deenweb,
              settings: {
                ...integrateData.deenweb.settings,
                termsOfService: {
                  description: JSON.stringify(textValue)
                }
              },
              pages: {
                ...pagesAll,
                termsOfServices: {
                  title: Title,
                  status: homepageButton ? 'active' : 'inactive',
                  enablePage: homepageButton,
                  quickAccess: checked,
                  lastEdited: new Date(),
                  pageName: 'About Us',
                }
              }
            }
          }
        }
      // const TOS = {
      //   description: JSON.stringify(textValue),
      //   organizationId: orgId
      // }
      try {
        console.log(data, "data")
        await saveAsDraft(orgId, data, token);
        // await AddTermOfServicesWebsite(TOS, token)
        setshowAlert(true);
        setsuccess(true)
        setValue(dischard_changes);
        setAlertModal(false)
      } catch (err) {
        seterror(err.response && err.response.data.message)
        setAlertModal(false)
        setTimeout(() => {
          seterror(false)
        }, 8000);
      }
    }
  };

  const publish = async () => {
    let pages = props?.pages?.pages
    let lengthOfPages = pages.filter(text => text.quickAccess === true);
    const orgId = localStorage.getItem('orgID');
    const token = localStorage.getItem('authToken');
    if (!value) {
      if (Title === '') {
        setErrorFound(true)
      } else {
        const data = {
          enabledIntegrations: {
            ...integrateData,
            deenweb: {
              ...integrateData.deenweb,
              settings: {
                ...integrateData.deenweb.settings,
                termsOfService: {
                  description: JSON.stringify(textValue)
                }
              },
              pages: {
                ...pagesAll,
                termsOfServices: {
                  title: Title,
                  status: homepageButton ? 'active' : 'inactive',
                  enablePage: homepageButton,
                  quickAccess: checked,
                  lastEdited: new Date(),
                  pageName: 'About Us',
                }
              }
            }
          }
        }
        // const TOS = {
        //   description: JSON.stringify(textValue),
        //   organizationId: orgId
        // }
        if (!checked || organizationData.quickAccess || lengthOfPages.length < 6) {
          try {
            console.log(data, "data")
            await saveAsDraft(orgId, data, token);
            // EmptyData._id ?
            //   await updateTermOfServicesWebsite(TOS, token, EmptyData._id)
            //   :
            //   await AddTermOfServicesWebsite(TOS, token)
            setshowAlert(true);
            setsuccess('Publish');
            setTimeout(() => {
              setsuccess(false)
            }, 8000);
            setCheckChanges(false)
            setAlertModal(false)
            setValue(dischard_changes);
            let Quick = pages.filter(text => text.name[0] !== "termsOfServices")
            Quick.push({
              name: ['termsOfServices'],
              quickAccess: checked
            })
            props.dispatchPagesAction(Quick)
            if (saved_route) {
              props.history.publish(saved_route);
            }
          } catch (err) {
            seterror(err.response && err.response.data.message)
            setAlertModal(false)
            setTimeout(() => {
              seterror(false)
            }, 8000);
          }
        } else {
          setQuickLimit(true)
          setTimeout(() => {
            setQuickLimit(false)
          }, 8000)
        }
      }
    } else {
      const data = {
        enabledIntegrations: {
          ...integrateData,
          deenweb: {
            ...integrateData.deenweb,
            settings: {
              ...integrateData.deenweb.settings,
              termsOfService: {
                description: JSON.stringify(textValue)
              }
            },
            pages: {
              ...pagesAll,
              termsOfServices: {
                title: Title,
                status: homepageButton ? 'active' : 'inactive',
                enablePage: homepageButton,
                quickAccess: checked,
                lastEdited: new Date(),
                pageName: 'About Us',
              }
            }
          }
        }
      }
      // let TOS = {
      //   description: JSON.stringify(textValue),
      //   organizationId: orgId
      // }
      if (!checked || organizationData.quickAccess || lengthOfPages.length < 6) {
        try {
          console.log(data, "data")
          await saveAsDraft(orgId, data, token);
          // EmptyData._id ?
          //   await updateTermOfServicesWebsite(TOS, token, EmptyData._id)
          //   :
          //   await AddTermOfServicesWebsite(TOS, token)
          setshowAlert(true);
          setAlertModal(false)
          setsuccess('Publish');
          setTimeout(() => {
            setsuccess(false)
          }, 8000);
          setCheckChanges(false)
          setValue(dischard_changes);
          let Quick = pages.filter(text => text.name[0] !== "termsOfServices")
          Quick.push({
            name: ['termsOfServices'],
            quickAccess: checked
          })
          props.dispatchPagesAction(Quick)
          if (saved_route) {
            props.history.push(saved_route);
          }
        } catch (err) {
          seterror(err.response && err.response.data.message)
          setAlertModal(false)
          setTimeout(() => {
            seterror(false)
          }, 8000);
        }
      } else {
        setQuickLimit(true)
        setTimeout(() => {
          setQuickLimit(false)
        }, 8000)
      }
    }
  };
  const saveStyles = {
    backgroundColor: "#2A82F6",
  };
  const publishStyles = {
    backgroundColor: "#2A82F6",
    opacity: 0.6,
  };
  const paperStyles = {};
  const styles = {
    BaseTextField: {
      width: "100%",
    },
    contents: {
      paddingTop: 20,
      paddingBottom: 0,
      display: "flex",
      flexDirection: "column",
      background: "#FFF",
      width: "100%",
      marginTop: 70,
      marginLeft: "14%",
    },
  };
  const [checked, setChecked] = useState(true);
  const handleClose = () => {
    setAlertModal(false)
  };
 const descChanges = (e) => {
   console.log("descChanges", e, textValue)
   if(e === textValue){
     checkChanges(false)
   }
   else{
     checkChanges(true)
   }
 }
  const info = (
    <>
      <Grid className="page_body">
        <Grid item md={12}>
          <Typography className="page_form_title">Terms of Services</Typography>
        </Grid>
        <Grid item md={6} className="page_body_inner">
          {/* <p className="desc">Description</p> */}
          <TextEditor
            onChange={(e) => { setTextValue(e); descChanges(e) }}
            value={textValue}
            maxCharCount={10000}
           // helperText={"Helper Text"}
            label={"Description"}
          />
          {/* <p className="MuiFormHelperText-root" style={{ marginTop: 3, marginBottom: 0 }}>
            <span
              style={{
                color: "rgb(211, 216, 218)",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  color: "rgb(182, 185, 185)",
                  alignSelf: "flex-end",
                  fontSize: 12,
                  marginTop: "4px",
                }}
              >
                CHAR 1246/10000
            </span>
            </span>
          </p> */}
        </Grid>
      </Grid>
    </>
  );
  const checkChanges = (boolean) => {
    setCheckChanges(boolean)
  }
  const style = {
    width: '100%',
  };
  const discardChanges = () => {
    setCheckChanges(false)
    setAlertModal(false)
    setValue(dischard_changes)
    setChecked(Object.keys(organizationData).length ? organizationData.quickAccess : false);
    setHomePageButton(Object.keys(organizationData).length ? organizationData.enablePage : false)
    setTitle(Object.keys(organizationData).length ? organizationData.title : '')
    if (unblockHandle) {
      unblockHandle.current()
    }
    if (saved_route) {
      props.history.push(saved_route)
    }
  };
  const Alertstyle = {
    width: 470,
    marginLeft: '35%'
  };
  return (
    <MasterLayoutMiddle
      header={
        <>
          <PageHeaderWithTabs
            back={() => props.history.push('/website/pages')}
            value={value}
            title="Terms of Services"
            object={object}
            disabled={changes ? false : true}
            indicatorColor="primary"
            style={{ color: "#2A82F6", border: "1px solid black" }}
            handleChange={(x, y) => handleChange(x, y)}
            indicatorColor="#2A82F6"
            saveStyles={saveStyles}
            publishStyles={publishStyles}
            hiddenDraft={true}
            paperStyles={paperStyles}
            saveChanges={() => saveChanges()}
            publish={() => publish()}
          />
          {
            showAlert && success && success === 'Publish' ? (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={Your_changes_has_been_published}
                  alertType={"success"}
                  onClick={() => setshowAlert(false)}
                />
              </div>
            ) : showAlert && success && (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={Your_changes_has_been_saved_as_draft}
                  alertType={"success"}
                  onClick={() => setshowAlert(false)}
                />
              </div>
            )
          }
          {
            error && (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={token_expired}
                  alertType={"error"}
                  onClick={() => seterror(false)}
                />
              </div>
            )
          }
          {
            QuickLimit && (
              <div style={{ zIndex: 9999, width: "60%", position: "fixed", top: 35, marginLeft: '70px' }}>
                <AlertAction
                  alert={quick_access_limit_axeeded}
                  alertType={"error"}
                  onClick={() => setQuickLimit(false)}
                />
              </div>
            )
          }
        </>
      }
      content={
        Loader ?
          <div
            style={{
              marginTop: 30,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress color="primary" />
          </div>
          :
          <>
            <div className="formBody">
              <div>
                <AlertDialogueAdvance
                  title="You have unsaved changes!"
                  description='There are unsaved changes. If you would like to save changes, press the "SAVE AS DRAFT" button.'
                  cancelText="Discard Changes"
                  confirmText="PUBLISH"
                  open={open}
                  handleCancel={() => publish()}
                  handleClose={() => handleClose()}
                  handleConfirm={() => discardChanges()}
                  styles={Alertstyle}
                />
              </div>
              {value === 1 && (
                <div className="page_body">
                  <Typography className="page_form_title">Page Settings</Typography>
                  <Grid className="form_body">
                    <Grid container item xs={6} spacing={3} >
                      <Grid item xs={12}>
                        <div className="field_box">
                          <BaseTextField
                            value={Title}
                            onChange={(e) => {
                              setTitle(e.target.value); checkChanges(true); setErrorFound(false)
                            }}
                            InputProps={false}
                            phone={false}
                            error={ErrorFound && !Title}
                            search={false}
                            count={20}
                            style={styles.BaseTextField}
                            color="primary"
                            disabled={false}
                           // helperText="Helper text"
                            label="Page Title"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="page_switch">
                          <FormSwitch
                            style={styles.BaseTextField}
                            headline="Enable Page"
                            body="Disabled pages can’t be accessed by your site visitors."
                            values={homepageButton}
                            handleSwitchChange={() => { setHomePageButton(!homepageButton); checkChanges(true) }}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="SolidBorder"></div>
                        <div className="checkBox">
                          <BaseCheckBox
                            label="Quick Access"
                            checked={checked}
                            color="secondary"
                            showHelperText={true}
                            helperText="Add to left navigation under QUICK ACCESS for quickly accessing the page"
                            onChange={(e) => { setChecked(e.target.checked); checkChanges(true) }}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              )}
              {value === 0 && <div>
                <div style={{ border: "1px solid #E8E9E9", marginTop: 24 }}>
                  <BasePaper
                    context={info}
                    square={false}
                    paperStyle={styles.paperStyleNext}
                  />
                </div>
              </div>}
            </div>
          </>
      }
      isFooter={true}
      footer={
        <FooterInner 
          style={style} 
          termsLink = {process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies" : "http://deenconnect.io/terms-policies" }
          privacyLink = {process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies#privacy-policy" : "http://deenconnect.io/terms-policies#privacy-policy"}
        />
      }
      isWhiteBackground={false}
    />
  );
}
const mapStateToProps = (state) => {
  return {
    pages: state.pages,
  };
};
const mapDispatchToProps = (dispatch) => ({
  dispatchPagesAction: (data) => dispatch(PagesAction(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TermsOfServices);
